<app-left-side-nav></app-left-side-nav>
<app-header></app-header>
<div class="container-fluid page-container">
    <div class="d-flex align-content-center justify-content-center wrapper">
        <div class="custom-width-container" *ngIf="!showSuccessMessage">
            <div class="right">
                <div class="basic-profile">
                    <div class="">
                        <div class="inner-content p-0">
                            <form class="" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
                                <div class="personal_info">
                                    <div class="top">
                                        <h4 class="text-start d-flex align-items-center">
                                            <a href="javascript:void(0)" (click)="onBackBtnClick()"
                                                class="link d-lg-none d-md-none d-sm-block"><span class="icon"><i
                                                        class="fa-solid fa-chevron-left me-3"></i></span></a>
                                            <span>Edit Profile</span>
                                        </h4>
                                    </div>
                                    <div class="info_sec">
                                        <div class="d-flex align-items-center inner-div">
                                            <div class="img-upload">
                                                <label for="profilepic">
                                                    <div class="img-box"
                                                        title="Image should be jpg, jpeg, png and less than 15 MB">
                                                        <img id="myImg" name="myImg" [src]="previewLogo"
                                                            alt="profile photo"
                                                            (error)="$any($event.target).src='/assets/images/Default-profile-photo.png'">
                                                        <span class="icon-cam"><i class="fa-solid fa-pen"></i></span>
                                                    </div>
                                                </label>
                                                <input id="profilepic" name="profilepic" formControlName="profilePic"
                                                    type="file" accept=".jpg,.jpeg,.png" class="d-none"
                                                    (change)="onProfileLogoSelected($event)" />
                                                <!-- <div class="err_msg text-center">{{ invalidImage }}</div> -->
                                            </div>
                                            <div class="google-sign">
                                                <p class="d-flex align-items-center mb-1">
                                                    Quick fill the profile with google</p>
                                                <!-- sign up with google button code start here -->
                                                <div id="signUpWithGoogle">
                                                    <button class="btn d-flex align-items-center google-sign-btn"
                                                        type="button" (click)="onGoogleIconClick()">
                                                        <img class="" src="/assets/images/brands-and-logotypes.png"
                                                            alt="google icon">
                                                        <span class="mt-1">Continue with Google</span>
                                                    </button>
                                                </div>
                                                <!-- sign up with google button code end here -->
                                            </div>
                                        </div>
                                        <div class="err_msg image-err-msg">{{ invalidImage }}</div>
                                    </div>
                                    <div class="row g-3">
                                        <div class="col-6 mt-22">
                                            <input type="text" class="form-control form-control-lg" placeholder="Name"
                                                formControlName="firstName" aria-label="First name" maxlength="60"
                                                (keydown)="preventLeadingSpace($event)"
                                                (keypress)="restrictInvalidChars($event)"
                                                (paste)="onPasteRemoveConsecutiveSpaces($event, 'firstName', 60)"
                                                (input)="enforceMaxLength($event,60)">
                                            <div class="error_msg_container">
                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('firstName')?.touched && registerForm.get('firstName')?.errors?.['required']">
                                                    First name is required.
                                                </span>
                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('firstName')?.value?.length === 60
                                                                            && !registerForm.get('firstName')?.errors?.['startsWithLetter']
                                                                            && !registerForm.get('firstName')?.errors?.['invalidName']
                                                                            && !registerForm.get('firstName')?.errors?.['consecutiveSpecials']">
                                                    Maximum 60 characters.
                                                </span>

                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('firstName')?.errors?.['minlength']">
                                                    Minimum 1 character required.
                                                </span>
                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('firstName')?.errors?.['startsWithLetter']
                                                                            || registerForm.get('firstName')?.errors?.['invalidName']
                                                                            || registerForm.get('firstName')?.errors?.['consecutiveSpecials']">
                                                    Invalid First Name.
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-6 mt-22">
                                            <input type="text" class="form-control form-control-lg"
                                                placeholder="Last Name" formControlName="lastName"
                                                aria-label="Last Name" maxlength="60"
                                                (keydown)="preventLeadingSpace($event)"
                                                (keypress)="restrictInvalidChars($event)"
                                                (paste)="onPasteRemoveConsecutiveSpaces($event, 'lastName', 60)"
                                                (input)="enforceMaxLength($event,60)">

                                            <div class="error_msg_container">
                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('lastName')?.touched && registerForm.get('lastName')?.errors?.['required']">
                                                    Last name is required.
                                                </span>
                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('lastName')?.value?.length === 60
                                                                            && !registerForm.get('lastName')?.errors?.['startsWithLetter']
                                                                            && !registerForm.get('lastName')?.errors?.['invalidName']
                                                                            && !registerForm.get('lastName')?.errors?.['consecutiveSpecials']">
                                                    Maximum 60 characters.
                                                </span>

                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('lastName')?.errors?.['minlength']">
                                                    Minimum 1 character required.
                                                </span>
                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('lastName')?.errors?.['startsWithLetter']
                                                                            || registerForm.get('lastName')?.errors?.['invalidName']
                                                                            || registerForm.get('lastName')?.errors?.['consecutiveSpecials']">
                                                    Invalid last name.
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-12 position-relative mt-22">
                                            <input type="text" class="form-control form-control-lg pe-custom"
                                                placeholder="Email" aria-label="Email" formControlName="email"
                                                (keydown)="preventAllSpace($event)" (input)="onEmailTypeChange($event)"
                                                maxlength="254">
                                            <div class="error_msg_container">
                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('email')?.errors?.['minlength'] && !registerForm.get('email')?.errors?.['invalidEmail']">
                                                    Minimum 7 characters required.
                                                </span>
                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('email')?.value?.length === 254 && !registerForm.get('email')?.errors?.['invalidEmail']">
                                                    Maximum 254 characters.
                                                </span>
                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('email')?.errors?.['invalidEmail']">
                                                    Invalid email format.
                                                </span>
                                                <span class="err_msg mt-1"
                                                    *ngIf="registerForm.get('email')?.errors?.['invalidTld'] && !registerForm.get('email')?.errors?.['invalidEmail']">
                                                    Invalid email domain.
                                                </span>
                                                <span class="err_msg mt-1"
                                                    *ngIf="isEmailAlreadyExist && !registerForm.get('email')?.errors?.['invalidEmail']">
                                                    Email already used
                                                </span>
                                            </div>
                                            <div *ngIf="(isEmailAlreadyExist || isValidEmail) 
                                                    && !registerForm.get('email')?.errors?.['invalidEmail']"
                                                class="email-error-icon position-absolute">
                                                <img [src]="isEmailAlreadyExist ? '/assets/images/attention.png' : '/assets/images/email-available.png'"
                                                    [alt]="isEmailAlreadyExist ? 'Email already used' : 'Available'"
                                                    [title]="isEmailAlreadyExist ? 'Email already used' : 'Available'" />
                                            </div>
                                            <div class="spinner-border text-primary loading-spinner" role="status"
                                                *ngIf="isLoadingEmailCheck">
                                                <span class="visually-hidden">Loading...</span>
                                            </div>
                                        </div>
                                        <div class="col-12 mt-0">
                                            <hr class="dotted-line">
                                        </div>
                                        <div class="col-12 mt-0">
                                            <select id="inputState" class="form-select form-select-lg"
                                                formControlName="state" required>
                                                <option value="" selected disabled>State</option>
                                                <option *ngFor="let s of states" [value]="s">{{ s }}</option>
                                            </select>
                                            <div class="text-danger err_msg mt-2"
                                                *ngIf="registerForm.get('state')?.touched && registerForm.get('state')?.hasError('required')">
                                                State is required.
                                            </div>
                                        </div>
                                        <div class="col-12 mt-22">
                                            <select id="inputCity" class="form-select form-select-lg"
                                                formControlName="city" required>
                                                <option value="" selected disabled>City</option>
                                                <option *ngFor="let c of cities" [value]="c">{{ c }}</option>
                                            </select>
                                            <div class="text-danger err_msg mt-2"
                                                *ngIf="registerForm.get('city')?.touched && registerForm.get('city')?.hasError('required')">
                                                City is required.
                                            </div>
                                        </div>

                                        <div class="col-12 mt-22">
                                            <div class="consent">
                                                <label class="form-check-label" for="whatsappConsent">
                                                    Receive OTP & updates on <img src="assets/images/whatsapp-icon.png"
                                                        alt="" width="22px">&nbsp;WhatsApp</label>
                                                <input class="form-check-input" type="checkbox"
                                                    formControlName="whatsAppConsent" id="whatsappConsent">
                                            </div>
                                        </div>
                                        <!-- Submit Button -->
                                        <div class="text-center footer-btn">
                                            <div class="btn-wrapper">
                                                <button type="submit" class="btn custom-btn-style"
                                                    [disabled]="registerForm.invalid || isEmailAlreadyExist">Save</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="success-msg" *ngIf="showSuccessMessage">
            <div class="text-center">
                <img src="/assets/images/success-leaf-img.gif" alt="success tick" class="mb-3 img-fluid" width="200">
                <h4 class="">Profile saved <br> successfully.</h4>
            </div>
        </div>
    </div>
</div>